import { PATHS_DOC } from 'src/routes/paths';

export const DOCS_NAV_CONFIG = [
  {
    title: 'Welcome',
    href: PATHS_DOC.WELCOME,
  },
  {
    title: 'Postman',
    href: PATHS_DOC.POSTMAN,
  },
  {
    title: 'Getting Started',
    href: PATHS_DOC.GETTING_STARTED,
  },
  {
    title: 'API',
    href: PATHS_DOC.API,
    items: [
      {
        title: 'Authentication',
        href: PATHS_DOC.AUTHENTICATION,
      },
      {
        title: 'Me',
        href: PATHS_DOC.ME,
      },
      {
        title: 'Feedback',
        href: PATHS_DOC.FEEDBACK,
      },
      {
        title: 'Mail',
        href: PATHS_DOC.MAIL,
      },
      {
        title: 'Cache',
        href: PATHS_DOC.CACHE,
      },
      {
        title: 'Metadata',
        href: PATHS_DOC.METADATA,
      },
      {
        title: 'Localization',
        href: PATHS_DOC.LOCALIZATION,
      },
      {
        title: 'Promo Code',
        href: PATHS_DOC.PROMO_CODE,
      },
      {
        title: 'Ticket',
        href: PATHS_DOC.TICKET,
      },
      {
        title: 'Store',
        href: PATHS_DOC.STORE,
      },
      {
        title: 'Report',
        href: PATHS_DOC.REPORT,
      },
      {
        title: 'Realtime Notification',
        href: PATHS_DOC.REALTIME_NOTIFICATION,
      },
      {
        title: 'Video',
        href: PATHS_DOC.VIDEO,
      },
      {
        title: 'Lullaby',
        href: PATHS_DOC.LULLABY,
      },
      {
        title: 'Whitelist',
        href: PATHS_DOC.WHITELIST,
      },
    ],
  },
  {
    title: 'Support',
    href: PATHS_DOC.SUPPORT,
  },
  {
    title: 'Changelog',
    href: PATHS_DOC.CHANGELOG,
  },
];
